import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { ForestInventoryStratum } from '../../domain/entities/ForestInventoryStratum'
import { IForestInventoryStratumRepository } from '../../domain/repositories/IForestInventoryStratum.repository'
import { ForestInventoryStratumClient } from './ForestInventoryStratumClient.abstract'
import { CreateForestInventoryStratumSchema } from '../schemas/CreateForestInventoryStratum.schema'
import { UpdateForestInventoryStratumSchema } from '../schemas/UpdateForestInventoryStratum.schema'

export class ForestInventoryStratumRepository implements IForestInventoryStratumRepository {
	private readonly _endpoint = '/v2/EstratoInventarioFlorestal'

	constructor(private readonly _httpClient: ForestInventoryStratumClient) {}

	async create(entity: ForestInventoryStratum): Promise<string> {
		const input = CreateForestInventoryStratumSchema.parse(entity)

		const response = await this._httpClient.post(
			`${this._endpoint}/salva-estrato-inventario-florestal-sortimento`,
			input,
			{ headers: { 'Content-Type': 'application/json' } },
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error(
				'Não foi possível salvar o estrato de inventário florestal. Por favor, tente novamente',
			)
		}

		return response.data
	}

	async update(entity: ForestInventoryStratum): Promise<void> {
		const input = UpdateForestInventoryStratumSchema.parse(entity)

		const response = await this._httpClient.put(
			`${this._endpoint}/edita-estrato-inventario-florestal-sortimento`,
			input,
			{ headers: { 'Content-Type': 'application/json' } },
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error(
				'Não foi possível editar o estrato de inventário florestal. Por favor, tente novamente',
			)
		}

		return
	}
}
